import React from 'react';
import styled from 'styled-components';

import { Card, Heading, InternalLink, animation, colors } from '../../ui-components';
import { Link } from 'gatsby';
import { cleanInternalUrl } from '../../utils/clean-internal-url';

/**
 * Component that renders ImageWithTitlesetCTACards
 *
 * @component ImageWithTitlesetCTACards
 * 
 * @param {object} props
 * 
 * @prop {string} title
 * @prop {boolean} noContent
 * @prop {string} layout
 * @prop {string} slug
 * @prop {boolean} secondaryColor
 * @prop {string} ctaText
 * @prop {string} geoSpace 
 * 
 * @return {JSX}
 */
const ImageWithTitlesetCTACards = props => {
  const { title, noContent, layout = 'withIcon', slug, secondaryColor, ctaText, geoSpace } = props;
  let cleanSlug = cleanInternalUrl(slug);
  let geoSpaceSlug = geoSpace && cleanSlug ? `/${geoSpace}${cleanSlug}` : cleanSlug ? cleanSlug : null;

  return (
    <WrapperLink to={geoSpaceSlug}>
      <CardContainer className={layout} noContent={noContent} secondaryColor={secondaryColor}>
        <Heading level={5}>{title}</Heading>
        {slug && (
          <AboutUsDetailLink to={slug} withArrow>
            {ctaText || 'Explore Further'}
          </AboutUsDetailLink>
        )}
      </CardContainer>
    </WrapperLink>
  );
};

const AboutUsDetailLink = styled(InternalLink)``;

const WrapperLink = styled(props => <Link {...props} />)`
  color: ${colors.midnightBlack};
  text-decoration: none;

  &:hover {
    ${AboutUsDetailLink} {
      text-decoration: underline;
    }

    svg.rightArrow {
      transition: color ${animation.general.durationAndTiming}, transform ${animation.general.durationAndTiming};
      transform: translateX(2px);
    }
  }
`;

const CardContainer = styled(Card)`
  box-shadow: 0px 0px 80px 0px rgba(0, 0, 0, 0.06);
  gap: 40px;
  padding: 28px;
  width: 100%;
  background: ${({ secondaryColor }) => (secondaryColor ? colors.lightSky : colors.pureWhite)};
`;

export default ImageWithTitlesetCTACards;
